import { createAuthClient } from "better-auth/react";
import { smartOnFhirClient } from "@/server/auth/plugins/smart-on-fhir/client";
import {
  adminClient,
  emailOTPClient,
  genericOAuthClient,
  inferAdditionalFields,
  magicLinkClient,
  oneTimeTokenClient,
  organizationClient,
} from "better-auth/client/plugins";
import { apiKeyClient } from "@better-auth/api-key/client";
import type { auth } from "@/server/auth";
import { oauthProviderClient } from "@better-auth/oauth-provider/client";

export const authClient = createAuthClient({
  baseURL: window.location.origin,
  sessionOptions: { refetchOnWindowFocus: false },
  plugins: [
    inferAdditionalFields<typeof auth>(),
    smartOnFhirClient(),
    adminClient(),
    emailOTPClient(),
    magicLinkClient(),
    genericOAuthClient(),
    oneTimeTokenClient(),
    organizationClient(),
    apiKeyClient(),
    oauthProviderClient(),
  ],
});

export const { signIn, signUp, signOut, useSession } = authClient;
